module.exports = __webpack_public_path__ + "static/media/greenhouse3-01.119ffcaa.webp";